import { Box, TextField, Button, Grid } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import {
  usePermiteAcesso,
} from "../../Components/Funcionais/Utils";
import PageTitle from "../../Components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import ListIcon from "@mui/icons-material/List";

const GrupoIncluir = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(3); //Cadastro de Grupos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
  });

  const handleVoltar = () => {
    navigate("/grupos");
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: typeof valor === "string" ? valor.toUpperCase() : valor,
    }));
  };

  // Limpa os campos do formulário após a inclusão, se for incluir mais um registro
  const limparCampos = () => {
    setFormData({
      id: 0,
      nome: "",
    });
  };

  // Recebe o clique no botao SALVAR ou no SALVAR + INCLUIR
  // Se for SALVAR + INCLUIR, chama a função limparCampos para limpar os campos do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    const response = await PostAPI(apiAxios, "/grupo", formData);

    setLoading(false);

    if (response.success) {
      setFormData(response.data);

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Perfil de grupo incluído com sucesso!");
      if (modoIncluirMais) {
        limparCampos();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 3000)); // aguarda 3 segundos
        navigate("/grupos");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar perfil.");
    }
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Cadastro de Grupos"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          justifyContent: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Descrição */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Grupo:"
                variant="outlined"
                value={formData.nome}
                onChange={(e) => handleChange(e, 50)}
                required
                name="nome"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between", // separa esquerda e direita
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mt: 2,
              }}
            >
              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", width: "100%" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  width: { xs: "100%", md: "auto" },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setModoIncluirMais(true)}
                  type="submit"
                  sx={{
                    borderColor: "#1a3865",
                    color: "#1a3865",
                  }}
                >
                  Salvar + Incluir
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    backgroundColor: "#1a3865",
                  }}
                  onClick={() => setModoIncluirMais(false)}
                  type="submit"
                >
                  Salvar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default GrupoIncluir;
